import { useEffect } from "react";
import { useSettings } from "../../context/SettingsContext";

function setMeta(name, content, attr = "name") {
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSeo(title, description) {
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
  }, [title, description]);
}

export const StructuredData = () => {
  const { settings } = useSettings();
  useEffect(() => {
    const id = "ld-local-business";
    document.getElementById(id)?.remove();
    if (!settings.phone) return undefined;
    const data = {
      "@context": "https://schema.org",
      "@type": "AutomotiveBusiness",
      name: settings.business_name,
      telephone: settings.phone,
      areaServed: { "@type": "City", name: `${settings.city}, ${settings.state}` },
    };
    if (settings.email) data.email = settings.email;
    if (settings.site_url) data.url = settings.site_url;
    if (settings.is_24_7) data.openingHours = "Mo-Su 00:00-23:59";
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.id = id;
    s.text = JSON.stringify(data);
    document.head.appendChild(s);
    return () => s.remove();
  }, [settings]);
  return null;
};
